import PolicyTipsOverrideDialog, {
    PolicyTipsOverrideInformation,
} from '../components/PolicyTipsOverrideDialog';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import { showModal, OwaModalProps } from 'owa-modal';
import setIsFalsePositive from '../actions/setIsFalsePositive';
import setOverrideJustification from '../actions/setOverrideJustification';
import { getHighestPriorityPolicyTipMatchDetail } from 'owa-policy-tips/lib/utils/getHighestPriorityPolicyTipMatchDetail';
import DlpPolicyMatchDetail from 'owa-service/lib/contract/DlpPolicyMatchDetail';
import React from 'react';

export default function showPolicyTipsOverrideDialog(viewState: PolicyTipsViewState) {
    const matchDetail: DlpPolicyMatchDetail = getHighestPriorityPolicyTipMatchDetail(
        viewState.succeededPolicyMatch
    );
    const wrappedComponent = ({ onDismiss }: OwaModalProps<PolicyTipsOverrideInformation>) => (
        <PolicyTipsOverrideDialog
            onDismiss={onDismiss}
            justificationMessage={matchDetail.JustificationMessage}
        />
    );
    const [modalPromise] = showModal(wrappedComponent);
    modalPromise.then(overrideState => {
        if (overrideState) {
            if (overrideState.isFalsePositive) {
                setIsFalsePositive(viewState, true);
            } else if (overrideState.justification && overrideState.justification.length > 0) {
                setOverrideJustification(viewState, overrideState.justification);
            }
        }
    });
}
